
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import signupDemo from './demo/signup.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/Mailchimp" parameters={{
      layout: 'fullscreen'
    }} mdxType="Meta" />
    <h1>{`Mailchimp`}</h1>
    <p>{`For convenience, we apply some default styles to Mailchimp signup forms. These assume that the "Remove CSS styles" option has been checked when `}<a parentName="p" {...{
        "href": "https://mailchimp.com/help/customize-embedded-signup-form/#Customize_your_embedded_form"
      }}>{`building the form`}</a>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Signup Form" argTypes={{
        show_example_content: {
          control: {
            type: 'boolean'
          }
        },
        transform_heading: {
          control: {
            type: 'boolean'
          }
        }
      }} mdxType="Story">
    {signupDemo.bind(this)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const signupForm = signupDemo.bind(this);
signupForm.storyName = 'Signup Form';
signupForm.argTypes = {
  show_example_content: {
    control: {
      type: 'boolean'
    }
  },
  transform_heading: {
    control: {
      type: 'boolean'
    }
  }
};
signupForm.parameters = { storySource: { source: 'signupDemo.bind(this)' } };

const componentMeta = { title: 'Vendor/Mailchimp', parameters: {
  layout: 'fullscreen'
}, includeStories: ["signupForm"],  };

const mdxStoryNameToKey = {"Signup Form":"signupForm"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;